import Styled from "styled-components"
import { Card } from 'antd';

export const CardHeader = Styled.div`

    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    justify-items: left;
    font-size: 1rem;

`

export const QuestionCard = Styled(Card)`

    width: 95%;

`